import React from 'react';
import { Root } from './styled.js';

const Footer = ({ children, justifyContent = 'flex-end', }) => {
    return (React.createElement(Root, { "$justifyContent": justifyContent, className: 'tend-ui-drawer-footer' }, children));
};
Footer.displayName = 'Drawer.Footer';

export { Footer };
